<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading" id="unnumbered-2">
<div class="heading heading-with-title heading-without-image" id="unnumbered-2-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">LUCY GUARDINO FBI THRILLERS</h1>
</div>
</div>
</div>
</div>
<div class="text" id="unnumbered-2-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center">With over a million copies sold, readers can’t get enough of Lucy Guardino, everyone’s favorite Pittsburgh soccer mom turned kick-ass FBI agent!</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center"><i>Don’t miss any of Lucy’s adventures:</i></p>
<p class="alignment-block-content alignment-block-content-center"><a class="content-external-link" href="http://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">SNAKE SKIN</a>, a USA Today Bestseller</p>
<p class="alignment-block-content alignment-block-content-center"><a class="content-external-link" href="http://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">BLOOD STAINED</a>, a USA Today Bestseller</p>
<p class="alignment-block-content alignment-block-content-center"><a class="content-external-link" href="http://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">KILL ZONE</a>, a Suspense Magazine Book of the Year</p>
<p class="alignment-block-content alignment-block-content-center"><a class="content-external-link" href="http://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">AFTER SHOCK</a>, a novella</p>
<p class="alignment-block-content alignment-block-content-center"><a class="content-external-link" href="http://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">HARD FALL</a>, Winner of the 2015 Thriller Award</p>
<p class="alignment-block-content alignment-block-content-center"><a class="content-external-link" href="http://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">BAD BREAK</a>, a novella</p>
<p class="alignment-block-content alignment-block-content-center"><i>and Lucy’s NEW Beacon Falls Mysteries:</i></p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<div class="inline-image inline-image-kind-photograph inline-image-size-large inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide inline-image-without-caption inline-image-begins-section inline-image-before-element-end">
<div class="inline-image-container">
<a class="link-contains-image" href="http://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">
<img alt="Beacon Falls" src="images/bflucy.jpg"/>
</a>
</div>
</div>
</div>
</div>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center"><a class="content-external-link" href="http://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">LAST LIGHT</a></p>
<p class="alignment-block-content alignment-block-content-center"><a class="content-external-link" href="http://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">DEVIL SMOKE</a></p>
<p class="alignment-block-content alignment-block-content-center"><a class="content-external-link" href="http://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">OPEN GRAVE</a></p>
<p class="alignment-block-content alignment-block-content-center"><a class="content-external-link" href="https://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">GONE DARK</a></p>
<p class="alignment-block-content alignment-block-content-center"><a class="content-external-link" href="https://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">BITTER TRUTH</a></p>
<p class="alignment-block-content alignment-block-content-center"><a class="content-external-link" href="https://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">LESSER EVIL</a></p>
</div>
</div>
<div class="blockquote-container prose without-attribution">
<blockquote class="prose without-attribution">
<div class="blockquote-image-block blockquote-image-aspect-wide">
<div class="blockquote-image-size-container">
<img alt="" class="blockquote-image-image" src="images/blockquote-big-66-screen.png"/>
</div>
</div>
<p class="first blockquote-content blockquote-content-prose blockquote-position-first blockquote-position-last">Everything a great thriller should be—action packed, authentic, and intense.” <i>~Lee Child</i></p>
</blockquote>
</div>
<p class="first first-in-chapter first-full-width first-after-blockquote"><span class="first-phrase">Want</span> to be the first to have a chance to read the new books? Sign up for my <a class="content-external-link" href="http://cjlyons.net/signup" target="_blank">Thrillers with Heart newsletter HERE</a>—and you’ll also get a <b>FREE</b> e-book!</p>
<p class="subsq"><i>(Already part of my Thrillers with Heart family? Feel free to share this offer with your thriller-loving friends!)</i></p>
<p class="subsq">Be sure to open the Thrillers with Heart emails; they’ll arrive every few months with info on contests, new books, and exclusive offers for my readers!</p>
<div class="inline-image inline-image-kind-freestanding inline-image-size-small inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide inline-image-without-caption inline-image-after-section-begin">
<div class="inline-image-container">
<a class="link-contains-image" href="http://cjlyons.net/signup" target="_blank">
<img alt="Thanks for reading! CJ" src="images/image-300thanks-448.jpg"/>
</a>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// lucy-guardino-fbi-thrillers.vue?4f3741f4